import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import PlaylistSummary from "models/PlaylistSummary";

var PlaylistCollection =  Backbone.Collection.extend({
    model: PlaylistSummary,


    initialize: function (models, options){
        this._sort_key ="name";
        this._context =  (options && options.context)? options.context :null;
    },

    url: function() {
        //return '/myOwnSongLibrary'; 
    },

    searchOnPlaylistName : function(letters, resultSize){
        if(letters == "")
        {
            if(resultSize)
            {
                return this.models.slice(0,resultSize );
            }else{
                return this.models;
            }
            
        }
        var resultFound = 0;
        letters  = letters.toLowerCase();
        
        var patternArray = [];
        var words = letters.split(/\s+/);
        for(let index in words){
            var escapedWord =  words[index].replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
            patternArray.push(new RegExp(escapedWord,"gi"));
        }
        return this.filter(function(data) {
            if(!resultSize || (resultSize  && resultFound < resultSize))
            {
                var found = true;
                for(let index in patternArray){
                    var pattern = patternArray[index];
                    found = pattern.test(data.get("name")) ; 
                    if(!found){
                        break;
                    }
                }
                if(found){
                    resultFound = resultFound+ 1;
                }
                
                return  found;
            }else{
                return false;
            }
        });
    },

    /*getPlaylistWithname : function(arrayOfPlaylistName){
        
 
        var foundModels =  this.filter(function(data) {
            return  (arrayOfPlaylistName.indexOf(data.get("name")) > -1);
            
        });
        var orderedModels = [];
        for(index in arrayOfURIs)
        {
            var uri = arrayOfURIs[index];
            for(index2 in foundModels)
            {
                var foundModel = foundModels[index2];
                if(foundModel.get("uri") == uri )
                {
                    orderedModels.push(foundModel);
                    break;
                }
            }
        }
        return orderedModels;
        
    },*/
    
     comparator: function(item) {
            var data = item.get(this._sort_key);
            if(data && ( typeof data == "string" || data instanceof String))
            {
                data = data.trim().toLowerCase();
            }
            return  data;
      },
      
      sortByField: function(fieldName) {
            this._sort_key = fieldName? fieldName : this._sort_key;
            this.sort();
      },

      getContext : function(){
            return this._context;
        },
        
        updateContext : function(newContext){
            this._context = newContext
        },
        
    
/*	getSongsAfter : function(songModel) {
        songIndex = this.indexOf(songModel);
        if (songIndex > -1) {
            arrayOfSongs = this.slice(songIndex + 1,
                this.length);
            return arrayOfSongs;
        } else {
            window.alertErrorMessage("song Not found in collection" + songIndex);
            return [];
        }
    },


    save: function(attrs, options){
        window.alertErrorMessage("attrs" + JSON.stringify(attrs));
        window.alertErrorMessage("options" + JSON.stringify(options));

        Backbone.sync('create', this, {
            success: function() {
                window.log('Saved!');
            },
            failure: function(){
                window.alertErrorMessage("savin..6");
            }
        });
    }*/
});
export default PlaylistCollection;